import { connect } from 'react-redux';

import selectors from '../selectors';
import ClerkAuthWrapper from '../components/ClerkAuthWrapper';

const mapStateToProps = (state) => {
  const isInitializing = selectors.selectIsInitializing(state);

  return {
    isInitializing,
  };
};

export default connect(mapStateToProps)(ClerkAuthWrapper);
